var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loading)?_c('loader'):_vm._e(),_c('FlashMessage',{attrs:{"position":'right top'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }